import React from 'react'
import AppRouter from './AppRouter';
import { AppLayout } from './Pages/AppLayout/AppLayout';
import GeneralState from '../store/GeneralState';

const App = () => (
	<GeneralState>
		<AppLayout>
			<AppRouter />
		</AppLayout>
	</GeneralState>
);

export default App
